module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoLt.5258bb66.otf";